import { AssetType, AssetTypeConfig } from "../types";
import { CameraIcon, CubeIcon, ScanIcon, MapPinIcon, ShapesIcon, SpeakerSimpleHighIcon, VideoCameraIcon } from "@phosphor-icons/react";

export const ASSET_TYPES_CONFIGS: Record<AssetType, AssetTypeConfig> = {
    '3d-model': {
        type: '3d-model',
        displayName: '3D Models',
        allowedMimeTypes: ['model/gltf-binary', 'model/gltf+json', 'model/fbx', 'model/obj', '.fbx', '.glb', '.gltf', '.obj'],
        maxFileSizeMb: 100,
        displayFileTypesAllowed: ['glb', 'gltf', 'fbx', 'obj', 'zip'],
        category: 'prop',
        previewComponent: '3d-model',
        icon: CubeIcon,
        assetCategory: ['character', 'prop']

    },
    'mask': {
        type: 'mask',
        displayName: 'Mask',
        allowedMimeTypes: ['model/gltf-binary', 'model/gltf+json', 'model/fbx', 'model/obj', '.fbx', '.glb', '.gltf', '.obj'],
        displayFileTypesAllowed: ['glb', 'gltf', 'fbx', 'obj', 'zip'],
        maxFileSizeMb: 25,
        category: 'mask',
        previewComponent: '3d-model',
        icon: ShapesIcon,
        assetCategory: ['']
    },
    'image': {
        type: 'image',
        displayName: 'Images',
        allowedMimeTypes: ['image/png', 'image/jpeg'],
        displayFileTypesAllowed: ['png', 'jpeg'],
        maxFileSizeMb: 25,
        category: 'image',
        previewComponent: 'image',
        icon: CameraIcon,
        assetCategory: ['']
    },
    'imageAnchor': {
        type: 'imageAnchor',
        displayName: 'Image Anchors',
        allowedMimeTypes: ['image/png', 'image/jpeg'],
        displayFileTypesAllowed: ['png', 'jpeg'],
        maxFileSizeMb: 25,
        category: 'image_anchor',
        previewComponent: 'image',
        icon: CameraIcon,
        assetCategory: ['']
    },
    'audio': {
        type: 'audio',
        displayName: 'Audio',
        allowedMimeTypes: ['audio/mp3', 'audio/wav', 'audio/ogg', 'audio/mpeg'],
        displayFileTypesAllowed: ['mp3', 'wav', 'ogg', 'mpeg'],
        maxFileSizeMb: 25,
        category: 'audio',
        previewComponent: 'audio',
        icon: SpeakerSimpleHighIcon,
        assetCategory: ['dialogue', 'sound effect', 'music']
    },
    'video': {
        type: 'video',
        displayName: 'Video',
        allowedMimeTypes: ['video/mp4', 'video/webm', 'video/quicktime', '.mp4', '.webm', '.mov'],
        displayFileTypesAllowed: ['mp4', 'webm', 'mov'],
        maxFileSizeMb: 100,
        category: 'video',
        previewComponent: 'video',
        icon: VideoCameraIcon,
        assetCategory: ['']
    },
    'scan': {
        type: 'scan',
        displayName: 'Immersal Scan',
        allowedMimeTypes: ['model/gltf-binary', '.glb', '.bytes', 'application/json'],
        displayFileTypesAllowed: ['glb', 'bytes', 'json'],
        maxFileSizeMb: 100, // Larger size for scan files
        category: 'immersal',
        previewComponent: '3d-model', // Use 3D preview for GLB
        icon: ScanIcon,
        assetCategory: ['immersal']
    },
    'openBrush': {
        type: 'openBrush',
        displayName: 'Open Brush',
        allowedMimeTypes: ['model/gltf-binary', '.glb'],
        displayFileTypesAllowed: ['glb'],
        maxFileSizeMb: 100,
        category: 'open_brush',
        previewComponent: '3d-model',
        icon: CubeIcon,
        assetCategory: ['open_brush']
    },
    'geospatial': {
        type: 'geospatial',
        displayName: 'Geospatial Anchor',
        allowedMimeTypes: [],
        displayFileTypesAllowed: [],
        maxFileSizeMb: 0,
        category: 'geospatial_anchor',
        previewComponent: 'image',
        icon: MapPinIcon,
        assetCategory: ['geospatial_anchor']
    }
};